import * as React from "react";
const SvgFiRrWonSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-won-sign_svg__a)">
      <path
        fill="#062147"
        d="M23 14h-1.16l2.15-12.85c.09-.54-.28-1.06-.82-1.15a.99.99 0 0 0-1.15.82L19.82 14h-5.81l-1.04-4.24A.995.995 0 0 0 12 9c-.46 0-.86.31-.97.76L9.99 14H4.18L1.99.82a1.004 1.004 0 0 0-1.98.33L2.16 14H1c-.55 0-1 .45-1 1s.45 1 1 1h1.49l.84 5.04c.27 1.64 1.57 2.82 3.22 2.95 1.66.13 3.12-.84 3.67-2.49l1.35-5.5h.88l1.37 5.57A3.5 3.5 0 0 0 17.17 24c.1 0 .2 0 .29-.01a3.5 3.5 0 0 0 3.22-2.95l.84-5.04h1.49c.55 0 1-.45 1-1s-.45-1-1-1zM8.29 20.94c-.28.85-1 1.09-1.59 1.05-.58-.05-1.26-.41-1.41-1.29l-.78-4.71H9.5l-1.21 4.94zm10.4-.23c-.15.88-.82 1.24-1.41 1.29-.58.04-1.31-.21-1.57-.98L14.48 16h4.98l-.78 4.71z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-won-sign_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWonSign;
